import * as React from 'react';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled, } from '@mui/material/styles';
import { Typography, } from '@mui/material';
import { useTheme } from '@emotion/react';
import grad from '../grad-bw.png';
import {
  SiBamboo, SiConfluence, SiKubernetes, SiDocker, SiNpm, SiMattermost,
  SiAwsamplify, SiJest, SiAsana, SiTypescript, SiRedux, SiExpress,
  SiSocketdotio, SiAdobephotoshop, SiAdobexd, SiFigma,
  SiMaterialdesign, SiMaterialui, SiWebpack, SiBabel,
  SiSubversion, SiPm2, SiMicrosoftteams, SiReact, SiHeroku,
  SiGithub, SiGit, SiBitbucket, SiJira, SiJavascript, SiPhp,
  SiNodedotjs, SiStripe, SiHtml5, SiCss3, SiAngular,
  SiMicrosoftsqlserver, SiMysql, SiMongodb,
} from 'react-icons/si';

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: '100%',
  width: '100%'
}));

const HorizontalScrollList = (props) => {
  return (
    <div style={{
      width: "calc(98% )",
      height: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
      margin: '1%',
      paddingBottom: 16,
    }}>
      {props.children.map((child, index) => <div
        key={`horizontal-list-${index}`}
        style={{
          borderRight: index === props.children.length - 1 ? '' : 'solid 1px #777',
          display: "inline-block",
          paddingRight: 4,
          paddingLeft: 4,
        }}
      >
        {child}
      </div>
      )}
    </div>
  );
}

const SkillIcon = (props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {props.children}
    </div>
  );
}

export default function DividerStack() {
  const theme = useTheme();

  const renderSkillIcon = (IconItem, label) => {
    return (
      <SkillIcon>
        <IconItem size={48} style={{ padding: 8, }} />
        <Typography variant="subtitle">{label}</Typography>
      </SkillIcon>
    );
  }

  return (
    <div>

      <Item sx={{ marginBottom: 2 }} >
        <Stack
          direction={{ xs: 'column-reverse', md: 'row-reverse' }}
          spacing={{ xs: 1, }}
          divider={<Divider orientation='vertical' flexItem />}
        >
          <Typography sx={{ display: { xs: 'flex', }, justifyContent: 'center', alignItems: 'center' }}>
            <img src={grad} alt="something" height={300} width={400} style={{}} />
          </Typography>
          <div style={{ width: '100%' }}>
            <Typography align="left" variant="h4" sx={{ fontWeight: 700, }}>
              Welcome,
              </Typography>
            <Typography align="left">
              I tried writing a fancy and professional introduction for my website however that proved to be difficult for
              my introverted personality, hmm, should've tried copying and pasting something from Google, ha!
              I think of myself to be an observer who doesn't say much during a conversation
              but will soon talk you to death with all my organized thoughts...or so I believe them to be.  Oops, no not object
              oriented progra..., sorry my sense of humor is showing ^__^ Oops as an I forgot to introduce myself, Hi I'm
              Bryan and, according to the Polytechnic University of Puerto Rico, I'm a Computer Engineer.
              I've been working as a full stack web developer for the past 5 years during which I've learned
              to architect & design complex business apps for Government entities and I love what I do!  I'm passionate
              about working with new technology, micro-controllers & internet of things, VR & AR, Photography, drones...
              phew! I wont drive you crazy reading about my hobbies, check out my blog and you will find some interesting
              and not so interesting stuff in there.  Anyways, I do take my Job and responsibilites
              seriously however It is of most importance to me that the people I work with recognize the value of laughing, smiling,
              helping and coffee... yes coffee.  Anyways... yet again... I kind of lost track of where I was going with this introduction thing.
              Please do browse around my page and leave a comment because why not!  Also, if you're interested in hiring me
              because of my super awesome unique skills, download my resume and contact me... if I already gave you my resume
              then disregard that since that is most likely how you ended up on this site anyways.  Thank you for reading my
              not so fancy and professional introduction!
            </Typography>
          </div>
        </Stack>
      </Item>

      <Item>


        <Typography align="center" variant="h5" sx={{ marginBottom: 2, fontWeight: 700, }}>
          Skills
        </Typography>
        <Stack
          direction={{ xs: 'column', md: 'row ' }}
          sx={{ marginRight: { xs: 2, md: 0 }, padding: 0, }}
        // spacing={{ xs: 1, sm: 1 }}
        // divider={<Divider orientation='vertical' flexItem />}
        >
          <div style={{
            width: "calc(100% )",
            overflowX: "auto",
            border: '1px solid', borderColor: theme.palette.divider, borderRadius: 4,
            margin: 8,
          }}>
            <Typography align="center" variant="h6" sx={{ fontWeight: 700, }}>
              Web Development
              </Typography>
            <Divider />
            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Front End
              </Typography>
            <HorizontalScrollList>
              {renderSkillIcon(SiHtml5, "HTML")}
              {renderSkillIcon(SiCss3, "CSS")}
              {renderSkillIcon(SiJavascript, "Javascript")}
              {renderSkillIcon(SiReact, "Reat JS")}
              {renderSkillIcon(SiAngular, "Angular")}
              {renderSkillIcon(SiRedux, "Redux")}
              {renderSkillIcon(SiStripe, "Stripe")}
              {renderSkillIcon(SiSocketdotio, "Socket IO")}
              {renderSkillIcon(SiTypescript, "Typescript")}
              {renderSkillIcon(SiNpm, "NPM")}
              {renderSkillIcon(SiJest, "Jest")}
              {renderSkillIcon(SiWebpack, "Webpack")}
              {renderSkillIcon(SiBabel, "Babel")}
            </HorizontalScrollList>

            <Divider />

            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Back End
            </Typography>
            <HorizontalScrollList>
              {renderSkillIcon(SiJavascript, "Javascript")}
              {renderSkillIcon(SiPhp, "PHP")}
              {renderSkillIcon(SiNodedotjs, "Node JS")}
              {renderSkillIcon(SiStripe, "Stripe")}
              {renderSkillIcon(SiExpress, "Express")}
              {renderSkillIcon(SiSocketdotio, "Socket IO")}
              {renderSkillIcon(SiPm2, "PM2")}
              {renderSkillIcon(SiTypescript, "Typescript")}
            </HorizontalScrollList>

            <Divider />
            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Databases
              </Typography>

            <HorizontalScrollList>
              {renderSkillIcon(SiMicrosoftsqlserver, "MS SQL Server")}
              {renderSkillIcon(SiMysql, "MySQL")}
              {renderSkillIcon(SiMongodb, "Mongo DB")}
            </HorizontalScrollList>

          </div>

          <div style={{
            width: "calc(100% )",
            overflowX: "auto",
            border: '1px solid', borderColor: theme.palette.divider, borderRadius: 4,
            margin: 8,
          }}>
            <Typography align="center" variant="h6" sx={{ fontWeight: 700, }}>
              Tools
              </Typography>
            <Divider />
            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Collaboration & Planning
              </Typography>
            <HorizontalScrollList>
              {renderSkillIcon(SiJira, "Jira")}
              {renderSkillIcon(SiConfluence, "Confluence")}
              {renderSkillIcon(SiMattermost, "Mattermost")}
              {renderSkillIcon(SiMicrosoftteams, "MS Teams")}
              {renderSkillIcon(SiAsana, "Asana")}
            </HorizontalScrollList>
            <Divider />

            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Source Control
              </Typography>
            <HorizontalScrollList>
              {renderSkillIcon(SiGit, "Git")}
              {renderSkillIcon(SiBitbucket, "Bitbucket")}
              {renderSkillIcon(SiSubversion, "Subversion")}
            </HorizontalScrollList>
            <Divider />

            <Typography align="center" variant="subtitle1" sx={{ fontWeight: 700, }}>
              Deployment
            </Typography>
            <HorizontalScrollList>
              {renderSkillIcon(SiBamboo, "Bamboo")}
              {renderSkillIcon(SiDocker, "Docker")}
              {renderSkillIcon(SiKubernetes, "Kubernetes")}
              {renderSkillIcon(SiAwsamplify, "AWS Amplify")}
              {renderSkillIcon(SiHeroku, "Heroku")}
              {renderSkillIcon(SiGithub, "Github")}
            </HorizontalScrollList>
          </div>

        </Stack >

        <Stack
          direction={{ xs: 'column', md: 'row ' }}
          sx={{ marginRight: { xs: 2, md: 0 }, padding: 0, }}
        >
          <div style={{
            width: "calc(100% )",
            overflowX: "auto",
            border: '1px solid', borderColor: theme.palette.divider, borderRadius: 4,
            margin: 8,
          }}>
            <Typography align="center" variant="h6" sx={{ fontWeight: 700, }}>
              UI/UX Design
              </Typography>
            <Divider />
            <HorizontalScrollList>
              {renderSkillIcon(SiAdobephotoshop, "Photoschop")}
              {renderSkillIcon(SiAdobexd, "Adobe Xd")}
              {renderSkillIcon(SiFigma, "Figma")}
              {renderSkillIcon(SiMaterialdesign, "Material Design")}
              {renderSkillIcon(SiMaterialui, "Material Ui")}
            </HorizontalScrollList>
          </div>

          <div style={{
            width: "calc(100% )",
            overflowX: "auto",
            border: '1px solid', borderColor: theme.palette.divider, borderRadius: 4,
            margin: 8,
          }}>
            <Typography align="center" variant="h6" sx={{ fontWeight: 700, }}>
              Mobile Development
              </Typography>

            <Divider />
            <HorizontalScrollList>
              {renderSkillIcon(SiReact, "React Native")}
              {renderSkillIcon(SiRedux, "Redux")}
              {renderSkillIcon(SiSocketdotio, "Socket Io")}
              {renderSkillIcon(SiTypescript, "Typescript")}
            </HorizontalScrollList>
          </div>
        </Stack>

      </Item>
    </div >
  );
}
